export default {
    type: 'panel',
    name: 'mainMenu',
    blocks: [
		{
			name: 'title',
			type: 'text',
			max: 1,
		},
		{
			name: 'links',
			type: 'mixed',
			blocks: [
				{
					name: 'mainLevel',
					type: 'link',
					max: 1,
				},
				{
					name: 'icon',
					type: 'image',
					max: 1,
				},
				{
					name: 'subLevel',
					type: 'link',
				},
			],
		},
	],
};
